import { ITypeTransport } from '../types/typeTransport.type';
import $http from '../services/AxiosInstance';
import { IErrorResponse } from '../types';

class TypeTransportsRepository {
  private endpoint = '/type-policy-transports';

  /**
   * Obtiene todos los tipos de transportes con paginación
   */
  async getTypeTransportsProPaginated(params: {
    page: number;
    deleted?: boolean;
    search?: string;
  }) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', params.page.toString());
      if (!!params?.deleted) {
        queryParams.append('deleted', params.deleted.toString());
      }
      if (params.search) {
        queryParams.append('search', params.search);
      }

      const response = await $http.get(
        `${this.endpoint}/pro?${queryParams.toString()}`,
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching type transports:', error);
      throw error;
    }
  }

  /**
   * Obtiene todos los tipos de transportes sin paginación
   */
  async getTypeTransports(): Promise<ITypeTransport[]> {
    try {
      const { data: { data: dataResponse } } = await $http.get(`${this.endpoint}/all`);
      return dataResponse;
    } catch (error) {
      console.error('Error fetching all type transports:', error);
      throw error;
    }
  }

  /**
   * Obtiene un tipo de transporte por ID
   */
  async getTypeTransportById(id: number) {
    try {
      const response = await $http.get(`${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching type transport:', error);
      throw error;
    }
  }

  /**
   * Crea un nuevo tipo de transporte
   */
  async createTypeTransport(data: ITypeTransport) {
    try {
      const response = await $http.post(this.endpoint, data);
      return response.data;
    } catch (error) {
      console.error('Error creating type transport:', error);
      throw error;
    }
  }

  /**
   * Actualiza un tipo de transporte existente
   */
  async updateTypeTransport(data: ITypeTransport) {
    try {
      const { id, ...payload } = data;
      const response = await $http.patch(`${this.endpoint}/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating type transport:', error);
      throw error;
    }
  }

  /**
   * Elimina un tipo de transporte (soft delete)
   */
  async deleteTypeTransport(id: number) {
    try {
      const response = await $http.delete(`${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting type transport:', error);
      throw error;
    }
  }

  /**
   * Restaura un tipo de transporte eliminado
   */
  async restoreTypeTransport(id: number) {
    try {
      const response = await $http.patch(
        `${this.endpoint}/${id}/restore`,
      );
      return response.data;
    } catch (error) {
      console.error('Error restoring type transport:', error);
      throw error;
    }
  }
}

export default new TypeTransportsRepository();
